import { render, staticRenderFns } from "./c_set_up.vue?vue&type=template&id=70359430&scoped=true"
import script from "./c_set_up.vue?vue&type=script&lang=js"
export * from "./c_set_up.vue?vue&type=script&lang=js"
import style0 from "./c_set_up.vue?vue&type=style&index=0&id=70359430&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70359430",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\a-项目\\付好佳\\多用户商城平台端\\fhj-web-dyh-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70359430')) {
      api.createRecord('70359430', component.options)
    } else {
      api.reload('70359430', component.options)
    }
    module.hot.accept("./c_set_up.vue?vue&type=template&id=70359430&scoped=true", function () {
      api.rerender('70359430', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pagediy/components/mobileConfigRight/c_set_up.vue"
export default component.exports